import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doPostFiles, doDownload, doDeleteBody } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getMonitoring = (id) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation`
  return doGet(url)
}

export const saveMonitoring = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation`
  return doPost(url, request)
}

export const updateMonitoring = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation/${request.id}`
  return doPut(url, request)
}

export const deleteMonitoring = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation/${monitoringId}`
  return doDelete(url)
}

//Attachments
export const getAttachments = (id) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation/attachments`
  return doGet(url)
}

export const getAttachmentsByFileId = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation/attachments/${fileId}`
  return doGet(url)
}
export const getDownload = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation/attachments/${fileId}/download`
  return doDownload(url)
}

export const saveAttachments = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation/attachments`
  return doPostFiles(url, request)
}

export const updateAttachments = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation/attachments/${request.id}`
  return doPut(url, request)
}

export const deleteAttachments = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/evaluation/attachments/${fileId}`
  return doDelete(url)
}

// /api/proposal/{projectVersionId}/monitoring/reportmethodology
export const saveReportmethodology = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/reportmethodology`
  return doPost(url, request)
}

// /api/proposal/{projectVersionId}/monitoring/reportmethodology
export const updateReportmethodology = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/monitoring/reportmethodology`
  return doPut(url, request)
}

// /api/proposal/{projectVersionId}/monitoring/reportmethodology
export const deleteReportmethodology = (projectVersionId, request) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/monitoring/reportmethodology`
  return doDeleteBody(url, request)
}

export const changeMonitoringAttachmentSeqNo = (projectVersionId, fileId, seqNo) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/monitoring/evaluation/attachments/${fileId}/${seqNo}`
  return doPut(url)
}
